<template>
  <popper
    :visible-arrow="false"
    :append-to-body="appendToBody"
    trigger="clickToToggle"
    :options="{
      placement,
    }"
    :forceShow="popperForceShow"
    @hide="hidePopover"
    @show="showPopover"
    @toggle="togglePopover"
    @documentClick="hidePopover"
    :id="idCalc"
    :disabled="disabled"
  >
    <div class="popper dropdown-popper-background">
      <DevEnvironmentsList v-if="popperForceShow" :site-id="site.id" @hide="hidePopover" />
    </div>
    <Btn slot="reference" :disabled="disabled">{{ getButtonText() }}</Btn>
  </popper>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import Btn from "@/components/display/Btn";
import DevEnvironmentsList from "@/pages/Dashboard/Plans/Plan/Site/DevEnvironmentsList";
import Popper from "@/components/display/Popper";
import { uniqueId } from "lodash-es";

export default {
  name: "DevEnvironmentsDropDown",
  components: { Btn, DevEnvironmentsList, Popper },
  props: {
    site: {
      type: Object,
      required: true,
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
    id: String,
    placement: {
      type: String,
      default: "bottom-end",
    },
    disabled: Boolean,
  },

  setup(props, { root }) {
    const idCalc = computed(() => props.id || uniqueId("dropdown-"));
    const popperForceShow = ref(false);

    const getButtonText = () => {
      const count = getEnvironmentCount();
      return `${root.$t("global.environments")}${count > 0 ? ` (${count})` : ""}`;
    };
    const getEnvironmentCount = () =>
      (props.site.devEnvironmentCount || 0) + (props.site.stagingEnvironmentCount || 0);

    const hidePopover = () => (popperForceShow.value = false);
    const showPopover = () => (popperForceShow.value = true);
    const togglePopover = () => (popperForceShow.value = !popperForceShow.value);

    return {
      idCalc,
      getButtonText,
      hidePopover,
      popperForceShow,
      showPopover,
      togglePopover,
    };
  },
};
</script>

<style lang="scss" scoped>
.popper {
  left: 5px !important;
  top: -5px !important;
  padding: 0;
  text-align: left;
}
</style>
